export enum EventPdfActions {
  EventPdfRequest = 'Request pdf for single event',
  EventPdfRequestSuccess = 'Successfully got pdf from API',
  EventPdfRequestFailure = 'Failure of getting pdf from API',
  ClearPdf = 'Clear Pdf',
}
